
var SDTString = 1
var SDTInteger = 2
var SDTEnumeration = 3

var SDTDate = 4
var SDTDateTime = 5
var SDTGene = 6
var SDTDecimal = 7
var SDTToolVector = 8
//
var KFTitle = 1
var KFSubtitle = 2
var KFAbstract = 3
// var KFGene = 4
// var KFToolVector = 5
var KFNA = 100
var KFSpecificat = 6

var taxTypeId = 61033
// var promoter1ID = 61034
// var tag2ID = 61035
// var euRID = 61036
// var proRID = 61037
// var promoter2ID = 61040
// var promoter3ID = 61041
// var tag1PUBID = 61042

var localStorege = {}
var emktMetaVersion = '0'
var isInit = false
var isDebug = false

var Rat = 'Rat'
var Mouse = 'Mouse'
var Human = 'Human'
var others = '其他'
var Gallusgallus = 'Gallus gallus'
var thalecress = 'thale cress'
var rice = 'rice'
var zebrafish = 'zebrafish'
var fruitfly = 'fruit fly'
var pig = 'pig'
var sheep = 'sheep'
var rabbit = 'rabbit'
var domesticsilkworm = 'domestic silkworm'
var Africanclawedfrog = 'African clawed frog'
var yeast = 'yeast'

var throttleLast, throttleDeferTimer

var isDesktop = false
var isResearchGroup = false
var isWapp = false
var isWappGuest = false
var isSecPromotion = false
var buyCartIsLocalStorage = true
const publicUrl = 'http://gmall.taogene.com/'
const wxShareUrl = publicUrl + 'wxShare'
const CONST_MESSAGE_STATUS_NONE = 1 /** 客户留言状态- 无留言 */
const CONST_MESSAGE_STATUS_NEW_MESSAGE = 2 /** 客户留言状态- 有留言  */
const CONST_MESSAGE_STATUS_NEW_RESPONSE = 3 /** 客户留言状态- 有回答  */
const CONST_MESSAGE_STATUS_RESPONSE_READ = 4 /** 客户留言状态- 回答已读  */

const CONST_MESSAGE_TYPE_CUSTOMER_REQUEST = 1 /** 留言状态- 客户提问 */
const CONST_MESSAGE_TYPE_CUSTOMER_SERVICE_RESPONSE = 2 /** 留言状态- 客服回答 */

const lotteryStartDT = new Date('2019/11/28 0:0:0') /** 感恩节首单抽奖有效日期 */
const lotteryEndDT = new Date('2019/12/31 23:59:59')
const christmasPreSalePeriod = ['2019/12/25 14:0:0', '2019/12/25 18:0:0', '2019/12/31 14:0:0', '2019/12/31 18:0:0', '2020/1/2 14:0:0', '2020/1/2 18:0:0']
const extraBloodType = ['2/5/6/8/9/DJ', '1/2/5/6/8/9/DJ', '1/9/Retro/PHP.eB', '2/8/9/DJ', '1/6/8/9']

const activityName = '三八女神节下单抽奖'
const promotionGuid = 'action-20201231-001'
const PRIZE_TYPE_OBJECT = 1 /** 实物奖品 **/
const PRIZE_TYPE_COUPON = 2 /** 优惠券奖品 **/
const AuthenticationID = 'action-authentication-001'
let customerBehaviours = {}
let behaviour = {}
let customerBehaviourType = {
  'click': 'click',
  'merchandise': 'merchandise',
  'search': 'search',
  'addCount': 'addCount',
  'minusCount': 'minusCount',
  'check': 'check',
  'deleteCart': 'deleteCart',
  'cancel': 'cancelDelete',
  'clickMer': 'clickMerchandiseAfterSearch'
}

// 接口来源
const FindSourceCrm = 'crm'

// 优惠券类别
const COUPON_TYPE_DISCOUNT = 5
// 优惠券类别-筑研服务抵用券
const COUPON_TYPE_SPECIAL_FUND = 6
const COUPON_TYPE = {
  prepaySpecialFundCoupon: 6 // 专享券
}
// 代金券类别 新增折扣类型
const COUPON_TYPE_NEW_DISCOUNT = 8
const testCustomerNo = '00198019' // leader '00198019'  member '00224747'
const testEnterpriseNo = '00000267'
const promotions618 = {}
const researchGroupStatusDictionary = {
  0: '未启用',
  1: '正常',
  2: '已冻结',
  3: '已过期'
}
const researchGroupApproveTypeDictionary = {
  0: '无需审批',
  1: '全部审批',
  2: '限额审批'
}
const WAPP_LOGIN_TYPE_CODE = 2
const WAPP_LOGIN_TYPE_WX = 1
const WAPP_LOGIN_TYPE_DICTIONARY = {
  [WAPP_LOGIN_TYPE_WX]: '/pages/login/login',
  [WAPP_LOGIN_TYPE_CODE]: '/pages/login/loginByCode'
}
const CONSTANT_APPROVETYPE_NONE = 0
const CONSTANT_APPROVETYPE_ALL = 1
const CONSTANT_APPROVETYPE_THRESHOLD = 2
const CONSTANT_SET_SINGLESTORKE_APPROVETYPE = 1
const CONSTANT_SET_MOUNTH_APPROVETYPE = 2
const CONSTANT_ALL_APPROVETYPE = 0
// 课题组审批结果
const RESEARCH_GROUP_APPROVE_RESULT_NEED_NOT_APPROVE = 0 // 不需要审批
const RESEARCH_GROUP_APPROVE_RESULT_NOT_OPERATED = 1 // 未审批
const RESEARCH_GROUP_APPROVE_RESULT_WAIT_APPROVE = 2 // 待审批
const RESEARCH_GROUP_APPROVE_RESULT_APPROVED = 3 // 审批通过
const RESEARCH_GROUP_APPROVE_RESULT_NOT_APPROVED = 4 // 审批未通过
// 订单状态
const ORDER_STATUS_DRAFT = 1
const ORDER_STATUS_SUBMITTED = 2
const ORDER_STATUS_PAIED = 3
const ORDER_STATUS_CONTRACT = 5
const ORDER_STATUS_FINISHED = 11
const ORDER_STATUS_ABORT = 12
const ORDER_STATUS_CHECK = 14
const ORDER_STATUS_SIGN_NEED = 15
const ORDER_STATUS_CHECK_BAD = 16
const ORDER_STATUS_WAIT_CHECK_SIGN_APPROVE = 17
const ORDER_STATUS_WAIT_PD_TECH_AUDIT = 18 // 产品类-待技术审核状态
const ORDER_STATUS_WAIT_PD_TECH_AUDIT_FAIL = 19 // 产品类-技术审核未通过状态

// 结算方式
const BALANCE_TYPE_RESEARCH_GROUP = 1
const BALANCE_TYPE_CUSTOMER = 0
// 支付方式
const PAY_TYPE_REMAIN_MONEY = 1
const PAY_TYPE_FAPIAO = 3
// 课题组状态
const RESEARCH_GROUP_STATUS_DISABLE = 0 // 未启用
const RESEARCH_GROUP_STATUS_NORMAL = 1 // 正常
const RESEARCH_GROUP_STATUS_LOCKED = 2 // 已冻结
const RESEARCH_GROUP_STATUS_EXPIRED = 3 // 已过期
// 结算账户状态
const SETTLEMENT_ACCOUNT_STATUS_DISABLE = 0 // 禁用
const SETTLEMENT_ACCOUNT_STATUS_NORMAL = 1 // 启用
const SETTLEMENT_ACCOUNT_STATUS_LOCKED = 2 // 注销
const SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP = 3 // 课题组结算账户

// 订单状态
const ORDER_TYPE_SERVICE = 3

// 产品类型
const PRODUCT_TYPE_TOOL = '产品类'
const CUSTOMIZE_IMAGE = 'Customize.jpg'
const PRODUCT_TYPE_SERVICE_CONSTANT = 99
// 订单管理页面tab区订单状态对应的tab值
const MYORDER_TAB_WAITPAY = 1
const MYORDER_TAB_EXECUTE = 2
const MYORDER_TAB_FINISHED = 3
const MYORDER_TAB_CANCELLED = 4
const MYORDER_TAB_WAITAUDIT = 5
// 判断是否是iphone全面屏
let isIphoneFullScreen = false
// 是否需要适配全面屏，从小程序过了且当前为全面屏
let leaveSpaceForFullScreen = false
const researchGroupDictionary = {
  '名称': 'researchGroupName',
  '编号': 'researchGroupNo',
  '单位': 'firstLevelEnterpriseName',
  '科室': 'secondLevelEnterpriseName',
  '负责人': 'leaderName',
  '审批人': 'approverName',
  '对账人': 'accountCustomerName',
  'A类折扣': 'discountA',
  'B类折扣': 'discountB',
  'C类折扣': 'discountC',
  '账期': 'creditPeriod',
  '课题组状态': 'status',
  '生效日期': 'startDT',
  '有效截止日期': 'endDT',
  '我的审批原则': 'approveType',
  '权益等级': 'vipLevel'
}
const researchGroupDetailDisplayOrder = ['名称', '编号', '单位', '科室', '负责人', '审批人', '对账人', 'A类折扣', 'B类折扣', 'C类折扣', '权益等级', '账期', '课题组状态', '生效日期', '有效截止日期', '我的审批原则']
const researchGroupMemberDictionary = {
  'memberName': '姓名',
  'mobile': '手机',
  'email': '邮箱',
  'firstLevelEnterpriseName': '单位',
  'secondLevelEnterpriseName': '科室',
  'createDT': '加入日期',
  'approveType': '审批原则',
  'approveThreshold': '审批限额'
}
const researchServiceCategory = '30'
const benefitDiscount = [{'tool': 8, 'service': 9}, {'tool': 7.5, 'service': 8.8}, {'tool': 7.2, 'service': 8.6}, {'tool': 7, 'service': 8.5}, {'tool': 6.5, 'service': 8}]
const HardGeneLevelNo1 = 1   // 困难基因级别-
const HardGeneLevelNo2 = 2  // 困难基因级别-二
const ENTERPRISE_TYPE_COMPANY = 7 // 单位类型-企业
const TOOLTYPE_LENTIVIRUS = '1'
const TOOLTYPE_PLASMID = '2'
const TOOLTYPE_ADENOVIRUS = '3'
const TOOLTYPE_RETROVIRUS = '6'
const TOOLTYPE_FLOATVIRUS = '7'
const TOOLTYPE_ADENOVIRUSABOUT = '4'  // 工具类型为腺病毒
const AAVBLOODTYPETWO = '2'  // 血清类型为2
const AAVBLOODTYPESIX = '6'  // 血清类型为6
const VIRUSTITER1E13 = '4'  // 病毒滴度为1E13
const VIRUSTITER5E12 = '9'  // 病毒滴度为5E12
const AMPLIFICATION = '3' // 合同选择为扩增产品
const CUSTOMERPROVIDED = '1' // 客户提供质粒
const ORDER_SOURCE = {
  EMKT: 1,
  SF: 2,
  OFFLINE: 3
}
// 地址状态
const ADDRESS_STATUS = {
  ADDRESS_STATUS_DRAFT: 1, // 草稿
  ADDRESS_STATUS_EFFECTIVE: 2, // 生效
  ADDRESS_STATUS_INVALID: 3 // 失效
}
// 地址来源
const ADDRESS_SOURCE = {
  ADDRESS_SOURCE_EMKT: 1, // 电商
  ADDRESS_SOURCE_SF: 2 // SF
}
// 实物类型
const MATERIAL_TYPE = {
  CELL: 1, // 目的细胞
  SAMPLE: 2, // 样本
  ANTIBODY: 3, // 抗体
  MEDICINE: 4, // 药物
  KIT: 6, // 试剂盒
  OTHER: 7, // 其他
  VIRUS: 8, // 病毒
  PLASMID: 9, // 质粒
  PRIMER: 10 // 引物
}
// 实物文件类型
const MATERIAL_FILETYPE = {
  SAMPLE_DELIVERY_GUIDE: 1, // 送样指南
  SAMPLE_INFO_SHEET: 2 // 实物信息表
}
// 收货地址
const DELIVERY_ADDRESS = {
  ADDRESS: '上海市浦东新区爱迪生路332号吉凯基因仓库',
  RECEIVER: '客供品管理员',
  PHONE: '021-61063988'
}
// 样本图标及快递展示状态
const SAMPLE_DISPLAY_TYPE = {
  DISPLAY_NMAE: 1, // 展示状态
  DISPLAY_ICON: 2 // 展示图标
}
// 进入送样单时来源类型
const SAMPLE_DELIVERY_FORM_TYPE = {
  fromAddSampleDelivery: 1, // 寄送实物
  fromModifySampleDelivery: 2 // 修改送样单
}
// 实物管理静态文件
const MATERIAL_STATIC_FILE_BASE_URL = '/emktResources/resocurces/img/material/'

// 商品图片静态文件
// const LOCATION_ORIGIN = 'https://www.genechemat.com:8443'
const LOCATION_ORIGIN = 'https://gmall.taogene.com'
const MERCHANDISE_IMG_BASE_URL = LOCATION_ORIGIN + '/emktResources/resocurces/img/merchandise/'

const MERCHANDISE_IMG_BASE_URL_RTMES = `${window.location.origin}/rtmes-client/`
const MERCHANDISE_IMG_BASE_URL_SMART = `${window.location.origin}/smart-center/gesource`
// 产品大类的角标iconTag
const PRODUCT_CATEGORY_ICON_TAG_AMPLIFICATION = 1
const PRODUCT_CATEGORY_ICON_TAG_STOCK = 2
const PRODUCT_CATEGORY_ICON_TAG_CUSTOMIZE = 3
const ICON_TAG_IMAGE_MAP = {
  [PRODUCT_CATEGORY_ICON_TAG_AMPLIFICATION]: 'amplification.png',
  [PRODUCT_CATEGORY_ICON_TAG_STOCK]: 'xianhuo.png',
  [PRODUCT_CATEGORY_ICON_TAG_CUSTOMIZE]: 'dingzhi.png'
}
// 产品类型
const PRODUCT_TYPE_ID = {
  instantStock: 1,
  produceStock: 2,
  customMade: 3,
  reagent: 4,
  amplification: 5,
  control: 6
}
// 载体图谱路径
const TV_NO_PATH = LOCATION_ORIGIN + '/emktResources/resocurces/img/promotion/SKUIMG/'

// 服务类进展推送
const ADBERRATION_EXCHANGE = 1  // 1：实验异常需交流；
const ADBERRATION_RETROACTION = 2 // 2：实验信息需反馈；
const ADBERRATION_REPORT = 3  // 3：进展汇报
const ADBERRATION_MESSAGE = {
  [ADBERRATION_EXCHANGE]: '实验服务出现异常，请点击异常实验查看详情',
  [ADBERRATION_RETROACTION]: '实验暂停中，请您尽快查看并回复邮件以继续开展实验',
  [ADBERRATION_REPORT]: '您的实验有进展，请点击有进展实验查看详情'
}
const ADBERRATION_STATUS = {
  [ADBERRATION_EXCHANGE]: '异常',
  [ADBERRATION_RETROACTION]: '待确认',
  [ADBERRATION_REPORT]: '有进展'
}
const EXPERIMENT_MODULES_STATUS_CANNOT_START = '无法开始'
const EXPERIMENT_MODULES_STATUS_READY_START = '准备开始'
const EXPERIMENT_MODULES_STATUS_ON_GOING = '进行中'
const EXPERIMENT_MODULES_STATUS_ENDING = '结束'
const EXPERIMENT_MODULES_STATUS_END_STOP = '终止'
const EXPERIMENT_MODULES_STATUS_NOT_START = '未开始'
const EXPERIMENT_MODULES_STATUS_STOP = '暂停中'
const EXPERIMENT_MODULES_STATUS_NAME_NOT_START = '未开始'
const EXPERIMENT_MODULES_STATUS_NAME__ON_GOING = '进行中'
const EXPERIMENT_MODULES_STATUS_NAME__ENDING = '已完成'
const EXPERIMENT_MODULES_STATUS_NAME__END_STOP = '终止'
const EXPERIMENT_MODULES_STATUS_NAME_EXCEPTION = '待确认'

const QUERY_ORDER_TYPE = {
  RESEARCHGROUP: 1,
  CUSTOMER: 2,
  SETTLEMENT_ACCOUNT: 4

}
function initCustomerBehaviour () {
  customerBehaviours = {
    'home': {
      'goToDetail': {},
      'search': {},
      'clickBanner': {},
      'clickLike': {}
    },
    'category': {
      'search': {},
      'goToCategoryDetail': {}
    },
    'news': {
      // todo
    },
    'cart': {
      'addCount': [],
      'minusCount': [],
      'goToDetail': {},
      'check': [],
      'unCheck': [],
      'checkAll': [],
      'unCheckAll': [],
      'deleteCart': [],
      'goToPay': {}
    },
    'me': {
      // todo
    },
    'categoryDetail': {},
    'merchandises': {},
    'searchresults': {
      'click': {}
    },
    'login': {},
    'register': {},
    'mobileLogin': {},
    'activation': {},
    'orders': {},
    'userInfo': {},
    'addressModify': {},
    'address': {},
    'addAddress': {},
    'changeLoginId': {},
    'passwordChange': {},
    'orderContentConfirm': {},
    'orderPayConfirm': {},
    'orderContent': {},
    'addressDetail': {},
    'orderConfirmDetail': {},
    'payDetail': {},
    'invoiceDetail': {},
    'promotions': {},
    'orderContentDetail': {},
    'successPay': {},
    'invoiceTitle': {},
    'myCoupons': {},
    'addInvoiceTitle': {},
    'myOrders': {},
    'forgetPassword': {},
    'myOrderDetail': {},
    'evaluation': {},
    'custOrder': {},
    'custOrder2': {},
    'dataMeta': {},
    'myDiscount': {},
    'myComment': {},
    'getComments': {},
    'applyCreditPay': {},
    'invoiceAddress': {},
    'myInvoiceAddress': {},
    'addInvoiceAddress': {},
    'invoiceAddressModify': {},
    'myMessage': {},
    'contact': {},
    'myAgreement': {},
    'myRecommend': {},
    'publicNumber': {},
    'myOrderCoupons': {},
    'compositions': {},
    'custDetail': {}
  }
  behaviour = {'time': '', 'target': '', 'type': ''}
}

// 优惠券活动类型：领取优惠券
const COUPON_ACTIVITY_TYPE_COUPON = 1
// 优惠券活动类型：拼团活动
const COUPON_ACTIVITY_TYPE_GROUP_BUY = 2
// 优惠券活动类型：20周年活动
const COUPON_ACTIVITY_TYPE_ANNIVERSARY = 3
initCustomerBehaviour()

// 本地持久化存储
const getLocalStorage = name => {
  if (!name) return
  if (localStorege[name]) {
    return localStorege[name]
  } else {
    if (!window.localStorage) {
      return
    }

    let content = window.localStorage.getItem(name)
    if (content) {
      localStorege[name] = JSON.parse(content)
      return localStorege[name]
    }
  }
}

const setLocalStorage = (name, content) => {
  if (!name) return
  localStorege[name] = content

  if (!window.localStorage) {
    return
  }

  content = JSON.stringify(content)
  try {
    window.localStorage.setItem(name, content)
  } catch (err) {
    // window.alert('local store :' + name + ',' + err)
    // 有可能是local storage quota 超出了， 尝试清除一下EmktAllKeywords，因为EmktAllKeywords比较大， 在空间不够的情况下，EmktAllKeywords会保存在内存里
    try {
      window.localStorage.removeItem('EmktAllKeywords')
      window.localStorage.setItem(name, content)
    } catch (error) {
      console.log('local store :' + name + ',' + error)
    }
  }
}
const setBuyCart = (name, content) => {
  if (buyCartIsLocalStorage) {
    setLocalStorage(name, content) // 非SF
  } else {
    setStoreItem(name, content)  // SF
  }
}

// 仅放在内存里面，不持久化到window.localStorage
const setStoreItem = (name, content) => {
  if (!name) return
  localStorege[name] = content
}

const removeStoreItem = (name) => {
  if (!name) return
  localStorege[name] = ''
}

const getStoreItem = (name) => {
  if (!name) return
  return localStorege[name]
}
function getEmktMetaVersion () {
  if (isInit === false) {
    init()
  }
  return emktMetaVersion
}

function getEmktMetaData () {
  return getLocalStorage('EmktMetaData')
}
function setEmktMetaData (emktMetaData) {
  if (emktMetaData) {
    setLocalStorage('EmktMetaData', emktMetaData)
    emktMetaVersion = emktMetaData.version
    window.document.cookie = 'EmktMetaVersion=' + emktMetaVersion
  }
}

function merchandiseWithMeta (merchandise) {
  if (!merchandise) {
    return merchandise
  }

  let attributes = merchandise.attributes
  let categoryAttrGroupsMap = getEmktMetaData().categoryAttrGroupsMap
  let BloodOptions = getLocalStorage('BloodOptions')
  let dictionariesMap = getEmktMetaData().dictionariesMap               // 字典
  let categoryAttrsMap = getEmktMetaData().categoryAttrsMap             // 属性的元数据
  let _attributes = {}                        // 属性
  let _attributesList = []                    // 属性列表
  let _customizableAttributes = {}            // 定制属性
  let _customizableAttrGroups = {}            // 定制属性组
  let _customizableAttrGroupsList = []        // 定制属性组列表

  merchandise._cycle = {label: '生产周期', value: merchandise.cycle, valueText: merchandise.cycle + '个工作日'}
  // 处理属性
  for (var attrName in attributes) {
    let attrVal
    let options = {}
    let attrMeta = categoryAttrsMap[merchandise.categoryId][attrName]
    let sdType = attrMeta.semanticDT
    let label = attrMeta.categoryAttrLabel
    let groupId = attrMeta.attrGroupId
    let sortOrder = attrMeta.sortOrder
    let keyFeature = attrMeta.keyFeature
    let displayable = attrMeta.displayable
    let columnName = attrMeta.columnName
    if (columnName === 'TVInfo.tag1PUBID' && merchandise.goodsNo === 'GTCL3481109223QA') {  // 该产品载体无荧光但是基因有荧光，因此去电【无荧光】显示
      displayable = 0
    }
    let sorteditAble = attrMeta.sorteditAble
    let sectionId = attrMeta.sectionId
    attrVal = {
      'label': label,
      'value': attributes[attrName],
      'sdType': sdType,
      'groupId': groupId,
      'sortOrder': sortOrder,
      'keyFeature': keyFeature,
      'displayable': displayable,
      'valueText': attributes[attrName],
      'columnName': columnName,
      'sorteditAble': sorteditAble,
      'sectionId': sectionId
    }
    // 修改元数据配置信息获取
    if (sdType === SDTEnumeration) { // 枚举类型
      let dicValue
      let aName = null
      if (attrMeta.extras) {
        // 血清型特殊处理
        if (attrMeta.extras.indexOf('^') !== -1) {
          aName = attrMeta.extras.substring(attrMeta.extras.indexOf('=') + 1, attrMeta.extras.indexOf('^'))
        } else {
          aName = attrMeta.extras.substring(11, attrMeta.length)
        }
        if (aName === '61029') {
          attrVal.valueText = BloodOptions[attributes[attrName]]
          attrVal.options = BloodOptions
        } else {
          if (attrMeta.extras.indexOf('^') !== -1) {
            dicValue = dictionariesMap[attrMeta.extras.substring(attrMeta.extras.indexOf('=') + 1, attrMeta.extras.indexOf('^'))]
          } else {
            dicValue = dictionariesMap[attrMeta.extras.substring(11, attrMeta.length)]
          }
        }
      }
      if (aName !== '61029') {
        for (var k in dicValue) {
          let val = dicValue[k]
          options[val.dictKey] = val.dictValue
        }
        attrVal.valueText = options[attributes[attrName]]
        attrVal.options = options
      }
    }
    _attributes[attrName] = attrVal
    _attributesList.push(attrVal)
  }
  // 结束本次修改
  // 属性列表排序
  var attributesSorter = function (a, b) {
    var sortOrderA = a.sortOrder
    var sortOrderB = b.sortOrder
    var keyFeatureA = a.keyFeature
    var keyFeatureB = b.keyFeature
    var r = keyFeatureA - keyFeatureB
    if (merchandise.categoryId === 12) {
      return sortOrderA - sortOrderB
    } else if (merchandise.categoryId === 20) {
      return a.sectionId - b.sectionId
    } else {
      if (r === 0) {
        r = sortOrderA - sortOrderB
      }
    }

    return r
  }
  var custattributesSorter = function (a, b) {
    var sortOrderA = a.sortOrder
    var sortOrderB = b.sortOrder
    if (merchandise.categoryId === 20) {
      return b.sectionId - a.sectionId
    } else {
      return sortOrderA - sortOrderB
    }
  }
  _attributesList.sort(attributesSorter)
  // 处理定制属性
  var customizableAttrNames = merchandise['customizableAttrNames']
  for (var idx in customizableAttrNames) {
    let attrName = customizableAttrNames[idx]
    if (attrName !== 'GeneInfo.category') {
      let attrVal
      let options = {}
      let attrMeta = categoryAttrsMap[merchandise.categoryId][attrName]
      let sdType = attrMeta.semanticDT
      let label = attrMeta.categoryAttrLabel
      let groupId = attrMeta.attrGroupId
      let sortOrder = attrMeta.sortOrder
      let columnName = attrMeta.columnName
      let customizable = attrMeta.customizable
      let description = attrMeta.description
      attrVal = {
        'label': label,
        'value': '',
        'sdType': sdType,
        'editAble': true,
        'sorteditAble': false,
        'customizable': customizable,
        'isNA': false,
        'groupId': groupId,
        'sortOrder': sortOrder,
        'error': '',
        'columnName': columnName,
        'description': description
      }
      attrVal.valueText = attrVal.value
      // if (attrName.indexOf('GeneInfo.') !== -1) {
      //   attrVal.editAble = false
      // }
      if (sdType === SDTEnumeration) { // 枚举类型
        let aName = null
        let dicValue
        if (attrMeta.extras) {
          // 血清型特殊处理
          if (attrMeta.extras.indexOf('^') !== -1) {
            aName = attrMeta.extras.substring(attrMeta.extras.indexOf('=') + 1, attrMeta.extras.indexOf('^'))
          } else {
            aName = attrMeta.extras.substring(11, attrMeta.length)
          }
          if (aName === '61029') {
            attrVal.valueText = ''
            attrVal.options = BloodOptions
          } else {
            if (attrMeta.extras.indexOf('^') !== -1) {
              dicValue = dictionariesMap[attrMeta.extras.substring(attrMeta.extras.indexOf('=') + 1, attrMeta.extras.indexOf('^'))]
            } else {
              dicValue = dictionariesMap[attrMeta.extras.substring(11, attrMeta.length)]
            }
          }
        }
        if (aName !== '61029') {
          for (var key in dicValue) {
            let val = dicValue[key]
            if (val.valid) { // 只有有效的选项才可以加入options
              options[val.dictKey] = val.dictValue
            }
          }
          attrVal.valueText = ''
          attrVal.options = options
        }
      } else if (sdType === SDTToolVector) {
        attrVal.options = []
      }
      /*
       if (sdType === SDTGene) { // 枚举类型
       var custGeneInfo1 = custGeneInfo(attrVal, groupId, dictionariesMap, sortOrder)
       // geneedit(sortOrder, custGeneInfo1, _customizableAttributes, 'GeneInfo_tax', attrVal, g, categoryAttrGroupsMap, _customizableAttrGroups, _customizableAttrGroupsList)
       // geneedit(sortOrder, custGeneInfo1, _customizableAttributes, 'GeneInfo_geneID', attrVal, g, categoryAttrGroupsMap, _customizableAttrGroups, _customizableAttrGroupsList)
       // geneedit(sortOrder, custGeneInfo1, _customizableAttributes, 'GeneInfo_NMID', attrVal, g, categoryAttrGroupsMap, _customizableAttrGroups, _customizableAttrGroupsList)
       let tax = custGeneInfo1['GeneInfo_tax']
       tax.editAble = false
       tax.sortOrder = sortOrder + 1
       var Id = attrVal.groupId
       _customizableAttributes['GeneInfo_tax'] = tax
       if (!g) {
       g = categoryAttrGroupsMap[tax.groupId]
       g.attrNames = []
       g.attrs = []
       _customizableAttrGroups[Id] = g
       _customizableAttrGroupsList.push(g)
       }
       g.attrNames.push('GeneInfo_tax')
       g.attrs.push(tax)
       let geneID = custGeneInfo1['GeneInfo_geneID']
       geneID.editAble = false
       geneID.sortOrder = sortOrder + 1
       _customizableAttributes['GeneInfo_geneID'] = geneID
       if (!g) {
       g = categoryAttrGroupsMap[geneID.groupId]
       g.attrNames = []
       g.attrs = []
       _customizableAttrGroups[Id] = g
       _customizableAttrGroupsList.push(g)
       }
       g.attrNames.push('GeneInfo_geneID')
       g.attrs.push(geneID)

       let NMID = custGeneInfo1['GeneInfo_NMID']
       NMID.editAble = false
       NMID.sortOrder = sortOrder + 1
       _customizableAttributes['GeneInfo_NMID'] = NMID
       if (!g) {
       g = categoryAttrGroupsMap[NMID.groupId]
       g.attrNames = []
       g.attrs = []
       _customizableAttrGroups[Id] = g
       _customizableAttrGroupsList.push(g)
       }
       g.attrNames.push('GeneInfo_NMID')
       g.attrs.push(NMID)
       }
       */
      // 处理定制属性组
      _customizableAttributes[attrName] = attrVal
      var attrGroupId = attrVal.groupId
      let g = _customizableAttrGroups[attrGroupId]
      if (!g) {
        g = {}
        let gmeta = categoryAttrGroupsMap[attrVal.groupId]
        g.attrGroupId = gmeta.attrGroupId
        g.groupLabel = gmeta.groupLabel
        g.sortOrder = gmeta.sortOrder
        g.attrNames = []
        g.attrs = []
        _customizableAttrGroups[attrGroupId] = g
        _customizableAttrGroupsList.push(g)
      }
      g.attrNames.push(attrName)
      g.attrs.push(attrVal)
    }
  }

  // // 定制组排序
  _customizableAttrGroupsList.sort(function (a, b) {
    return a.attrGroupId - b.attrGroupId
  })

  // 定制属性排序
  for (let grpIdx in _customizableAttrGroupsList) {
    var grp = _customizableAttrGroupsList[grpIdx]
    grp.attrs.sort(custattributesSorter)
  }
  let _titleList = []
  let _subTitleList = []
  let _abstractList = []
  let _specificatList = []
  for (var attrIdx in _attributesList) {
    let attribute = _attributesList[attrIdx]
    if (merchandise.categoryId === 10) {
      let label = attribute.label
      if (label === '基因名') {
        if (attribute.value !== '-1') {
          _titleList.push(attribute)
        }
      }
      if (label === '调控目的') {
        if (attribute.value !== '-1') {
          _subTitleList.push(attribute)
        }
      }
      if (label === '靶点提供方案') {
        if (attribute.value !== '-1') {
          _abstractList.push(attribute)
        }
      }
    } else if (merchandise.categoryId === 20) {
      let label = attribute.label
      if (label === '基因' && attribute.value) {
        if (typeof attribute.value === 'object') {
          let taxId = {}
          let dictionary = getEmktMetaData().dictionariesMap
          taxId.columnName = 'GeneInfo.taxId'
          taxId.value = dictionary[61033][attribute.value.taxId].dictValue
          taxId.valueText = taxId.value
          let symbol = {}
          symbol.columnName = 'GeneInfo.symbol'
          symbol.value = attribute.value.symbol
          symbol.valueText = attribute.value.symbol
          _abstractList.push(taxId)
          _abstractList.push(symbol)
          // abstractTitles = abstractTitles + ' ' + taxId
          // abstractTitles = abstractTitles + ' ' + symbol
        } else if (attribute.value.toString().startsWith('{')) {
          attribute.value = JSON.parse(attribute.value)
          let taxId = {}
          let dictionary = getEmktMetaData().dictionariesMap
          taxId.columnName = 'GeneInfo.taxId'
          taxId.value = dictionary[61033][attribute.value.taxId].dictValue
          taxId.valueText = taxId.value
          let symbol = {}
          symbol.columnName = 'GeneInfo.symbol'
          symbol.value = attribute.value.symbol
          symbol.valueText = attribute.value.symbol
          _abstractList.push(taxId)
          _abstractList.push(symbol)
        }
      }
    } else {
      if (merchandise.categoryId !== 12 && merchandise.categoryId !== 20) {
        if (attribute.keyFeature >= KFNA) {
          break
        }
      }
    }
    if (attribute.value !== '-1' && attribute.value !== undefined && attribute.value !== '214' && attribute.value !== 214 && attribute.value !== -1) {
      if (attribute.keyFeature === KFTitle) {
        if (!(attribute.columnName === 'TVInfo.tag1PUBID' && merchandise.goodsNo === 'GTCL3481109223QA')) {  // 该产品载体无荧光但是基因有荧光，因此去电【无荧光】显示
          _titleList.push(attribute)
        }
      } else if (attribute.keyFeature === KFSubtitle) {
        _subTitleList.push(attribute)
      } else if (attribute.keyFeature === KFAbstract) {
        _abstractList.push(attribute)
      } else if (attribute.keyFeature === KFSpecificat) {
        _specificatList.push(attribute)
      }
    }
  }
  let name = {}
  if (merchandise.categoryId !== 20) {
    name.valueText = merchandise.productName
    _titleList.push(name)
  }
  merchandise['_attributes'] = _attributes
  merchandise['_attributesList'] = _attributesList
  if (merchandise.categoryId !== 10) {
    _titleList.sort(function (a, b) {
      return a.sortOrder - b.sortOrder
    })
    _subTitleList.sort(function (a, b) {
      return a.sortOrder - b.sortOrder
    })
    _abstractList.sort(function (a, b) {
      return a.sortOrder - b.sortOrder
    })
    _attributesList.sort(function (a, b) {
      return a.sortOrder - b.sortOrder
    })
  }
  var i = 0
  if (merchandise.bpromotions) {
    var promotions = []
    for (i = 0; i < merchandise.bpromotions.length; i++) {
      if (merchandise.bpromotions[i].type === 3 && merchandise.bpromotions[i].emktIsShow === 1) {
        promotions.push(merchandise.bpromotions[i])
      } else if (merchandise.bpromotions[i].type !== 3) {
        promotions.push(merchandise.bpromotions[i])
      }
    }
    merchandise.bpromotions = promotions
    merchandise.bpromotions.sort(function (a, b) {
      return a.priority - b.priority
    })
  }
  if (merchandise.promotions) {
    var dpromotions = []
    for (i = 0; i < merchandise.promotions.length; i++) {
      if (merchandise.promotions[i].type === 3 && merchandise.promotions[i].emktIsShow === 1) {
        dpromotions.push(merchandise.promotions[i])
      } else if (merchandise.promotions[i].type !== 3) {
        dpromotions.push(merchandise.promotions[i])
      }
    }
    merchandise.promotions = dpromotions
    merchandise.promotions.sort(function (a, b) {
      return a.priority - b.priority
    })
  }
  merchandise['_titleList'] = _titleList
  merchandise['_subTitleList'] = _subTitleList
  merchandise['_abstractList'] = _abstractList
  merchandise['_specificatList'] = _specificatList
  merchandise['_customizableAttrGroupsList'] = _customizableAttrGroupsList
  merchandise['_customizableAttrGroups'] = _customizableAttrGroups
  merchandise['_customizableAttributes'] = _customizableAttributes
  return merchandise
}
function init () {
  var emktMetaData = getLocalStorage('EmktMetaData')
  if (emktMetaData) {
    emktMetaVersion = emktMetaData.version
  }
  window.document.cookie = 'EmktMetaVersion=' + emktMetaVersion
  isInit = true
}
// 获取订单中商品类型显示标签 deprecated
function getMerchandiseLabelPath (merchandise) {
  const route = '/static/img/'
  return getMerchandiseLabelImg(route, merchandise)
}
function getMerchandiseLabelImg (route, merchandise) {
  if (merchandise.categoryId === 20 || merchandise.categoryId === 10 || merchandise.isStock === 0) {
    return (merchandise.fromEmkt && merchandise.name && merchandise.name.includes('扩增')) ? route + '扩增标签.png' : route + '定制标签.png'
  } else {
    return route + '现货标签.png'
  }
}
function getOrderMerchandiseLabel (merchandise) {
  return getMerchandiseLabelImg(MERCHANDISE_IMG_BASE_URL, merchandise)
}
// 获取文件显示图标
function getOrderMaterialFileShowIcon (fileName) {
  const route = MATERIAL_STATIC_FILE_BASE_URL + 'other/'
  if (fileName !== undefined) {
    var suffix = getFileSuffix(fileName)
    if (suffix === 'pdf') {
      return route + 'pdf.svg'
    } else if (suffix === 'mp4') {
      return route + 'mp4.svg'
    } else if (suffix === 'doc' || suffix === 'docx') {
      return route + 'word.svg'
    } else if (suffix === 'xls' || suffix === 'xlsx') {
      return route + 'excel.svg'
    } else {
      return route + 'file_default.svg'
    }
  }
}
function reassembleOrderMaterialInfo (orderMaterialInfo) {
  let orderMaterial = []
  let initFileList = []
  orderMaterialInfo.forEach(material => {
    material.orderMaterial.isChecked = false
    orderMaterial.push({orderMaterial: material.orderMaterial, orderMaterialDetail: {infoReceived: false, orderMaterialId: material.orderMaterial.orderMaterialId}})
    if (material.initFileList) {
      material.initFileList.forEach(initFile => {
        initFileList.push(initFile)
      })
    }
  })
  return {orderMaterial: orderMaterial, initFileList: initFileList}
}
function getFileSuffix (fileName) {
  return fileName.substring(fileName.lastIndexOf('.') + 1)
}
// function custGene (attrVal, _attributes, _attributesList, groupId, dictionariesMap, sortOrder) {
//   attrVal.displayable = 0
//
//   let symbol = {}
//   symbol.label = '基因名'
//   if (attrVal.value) {
//     symbol.value = attrVal.value.symbol
//     symbol.valueText = symbol.value
//   } else {
//     symbol.value = ''
//     symbol.valueText = ''
//   }
//   symbol.sdType = SDTString
//   symbol.groupId = groupId
//   symbol.sortOrder = sortOrder
//   symbol.keyFeature = KFTitle
//   symbol.displayable = true
//   _attributes['GeneInfo_symbol'] = symbol
//   _attributesList.push(symbol)
//
//   let tax = {}
//   tax.label = '组织类型'
//   if (attrVal.value) {
//     tax.value = dictionariesMap[taxTypeId][attrVal.value.taxId].dictValue
//     tax.valueText = tax.value
//   } else {
//     tax.value = ''
//     tax.valueText = ''
//   }
//   tax.sdType = SDTEnumeration
//   tax.groupId = groupId
//   tax.sortOrder = sortOrder
//   tax.keyFeature = KFSubtitle
//   tax.displayable = true
//   _attributes['GeneInfo_tax'] = tax
//   _attributesList.push(tax)
//
//   let geneID = {}
//   geneID.label = '基因ID'
//   if (attrVal.value) {
//     geneID.value = attrVal.value.geneID
//     geneID.valueText = geneID.value
//   } else {
//     geneID.value = ''
//     geneID.valueText = ''
//   }
//   geneID.sdType = SDTString
//   geneID.groupId = groupId
//   geneID.sortOrder = sortOrder
//   geneID.keyFeature = KFNA
//   geneID.displayable = true
//   _attributes['GeneInfo_geneID'] = geneID
//   _attributesList.push(geneID)
//
//   let NMID = {}
//   NMID.label = 'bankid'
//   if (attrVal.value) {
//     NMID.value = attrVal.value.NMID
//     NMID.valueText = NMID.value
//   } else {
//     NMID.value = ''
//     NMID.valueText = ''
//   }
//   NMID.sdType = SDTString
//   NMID.groupId = groupId
//   NMID.sortOrder = sortOrder
//   NMID.keyFeature = KFNA
//   NMID.displayable = true
//   _attributes['GeneInfo_NMID'] = NMID
//   _attributesList.push(NMID)
// }
/*
function custGeneInfo (attrVal, groupId, dictionariesMap, sortOrder) {
  attrVal.displayable = 0
  let symbol = {}
  var custGeneInfo = {}
  symbol.label = '基因名'
  if (attrVal.value) {
    symbol.value = attrVal.value.symbol
    symbol.valueText = symbol.value
  } else {
    symbol.value = ''
    symbol.valueText = ''
  }
  symbol.sdType = SDTString
  symbol.groupId = groupId
  symbol.sortOrder = sortOrder
  symbol.keyFeature = KFTitle
  symbol.displayable = true
  custGeneInfo['GeneInfo_symbol'] = symbol
  let tax = {}
  tax.label = '组织类型'
  if (attrVal.value) {
    tax.value = dictionariesMap[taxTypeId][attrVal.value.taxId].dictValue
    tax.valueText = tax.value
  } else {
    tax.value = ''
    tax.valueText = ''
  }
  tax.sdType = SDTEnumeration
  tax.groupId = groupId
  tax.sortOrder = sortOrder
  tax.keyFeature = KFSubtitle
  tax.displayable = true
  custGeneInfo['GeneInfo_tax'] = tax
  let geneID = {}
  geneID.label = '基因ID'
  if (attrVal.value) {
    geneID.value = attrVal.value.geneID
    geneID.valueText = geneID.value
  } else {
    geneID.value = ''
    geneID.valueText = ''
  }
  geneID.sdType = SDTString
  geneID.groupId = groupId
  geneID.sortOrder = sortOrder
  geneID.keyFeature = KFNA
  geneID.displayable = true
  custGeneInfo['GeneInfo_geneID'] = geneID
  let NMID = {}
  NMID.label = 'bankid'
  if (attrVal.value) {
    NMID.value = attrVal.value.NMID
    NMID.valueText = NMID.value
  } else {
    NMID.value = ''
    NMID.valueText = ''
  }
  NMID.sdType = SDTString
  NMID.groupId = groupId
  NMID.sortOrder = sortOrder
  NMID.keyFeature = KFNA
  NMID.displayable = true
  custGeneInfo['GeneInfo_NMID'] = NMID
  return custGeneInfo
}
*/
// function geneedit (sortOrder, custGeneInfo1, _customizableAttributes, name, attrVal, g, categoryAttrGroupsMap, _customizableAttrGroups, _customizableAttrGroupsList) {
//   let tax = custGeneInfo1[name]
//   alert(name)
//   tax.editAble = false
//   tax.sortOrder = sortOrder + 1
//   var Id = attrVal.groupId
//   _customizableAttributes[name] = tax
//   if (!g) {
//     g = categoryAttrGroupsMap[tax.groupId]
//     g.attrNames = []
//     g.attrs = []
//     _customizableAttrGroups[Id] = g
//     _customizableAttrGroupsList.push(g)
//   }
//   g.attrNames.push(name)
//   g.attrs.push(tax)
// }
function throttle (fn, threshhold, scope) {
  threshhold || (threshhold = 250)

  var context = scope || this
  var now = new Date().getTime()
  var args = arguments
  if (throttleLast && now < throttleLast + threshhold) {
    // hold on to it
    clearTimeout(throttleDeferTimer)
    throttleDeferTimer = setTimeout(function () {
      throttleLast = now
      fn.apply(context, args)
    }, threshhold)
  } else {
    throttleLast = now
    fn.apply(context, args)
  }
}
function openCustomerService () {
  window.open('https://imxcx1.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=082583ee-1b2d-4d17-bfa4-7a027eb0c4e5')
}
// 获取url中的参数
function getUrlParam (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i') // 构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg)  // 匹配目标参数
  if (r != null) return decodeURIComponent(r[2])

  return null // 返回参数值
}
// 获取参数全名
function getFullUrlParam (val) {
  var uri = window.location.href
  var re = new RegExp('' + val + '=([^&?]*)', 'ig')
  return ((uri.match(re)) ? (uri.match(re)[0].substr(val.length + 1).substring(0)) : null)
}
function getUrlParamHref (val) {
  var uri = window.location.href
  var re = new RegExp('' + val + '=([^&?]*)', 'ig')
  return ((uri.match(re)) ? (uri.match(re)[0].substr(val.length + 1).substring(0, 1)) : null)
}
function getUrlFullParamValue (val) {
  let queryString = window.location.search.substr(1)
  let queryparam = new URLSearchParams(queryString)
  let params = Object.fromEntries(queryparam)
  return params[val] || null
}
function isNullOrBlankObject (obj) {
  return !obj || JSON.stringify(obj) === '{}'
}
// 格式化价格 10,000，且保留两位小数
function formatPrice (moneyNumber) {
  if (moneyNumber === 0) {
    return '0.00'
  }
  if (!moneyNumber) {
    return ''
  }
  return String(moneyNumber.toFixed(2)).replace(/\B(?=(?:\d{3})+\b)/g, ',')
}

const RESEARCH_MEMBER_OP = {
  approval: 2,
  add: 1
}
function FormatterTime (date) {
  let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let currentDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let currenthours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let currentMinutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let currentSeconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  var newTime = date.getFullYear() + '-' + month + '-' + currentDate + ' ' + currenthours + ':' + currentMinutes + ':' + currentSeconds
  return newTime
}

function getOrderStatusText (order) {
  let text = ''
  if (order.itemList) {
    for (let i = 0; i < order.itemList.length; i++) {
      let sfQuoteStatus = order.itemList[i].sfQuoteStatus
      // 待审核
      if (sfQuoteStatus && sfQuoteStatus === 3) {
        text = '待审核'
        break
      }
    }
  }
  if (!text) {
    switch (order.status) {
      case ORDER_STATUS_DRAFT:
      case ORDER_STATUS_SUBMITTED:
        text = order.approveResult === RESEARCH_GROUP_APPROVE_RESULT_WAIT_APPROVE ? '待审批' : '待提交'
        break
      case ORDER_STATUS_FINISHED:
        text = '已完成'
        break
      case ORDER_STATUS_ABORT:
        text = '已取消'
        break
      case ORDER_STATUS_CHECK:
        text = '技术审核中'
        break
      case ORDER_STATUS_CHECK_BAD:
        text = '审核不通过'
        break
      case ORDER_STATUS_SIGN_NEED:
        text = '待签署'
        break
      case ORDER_STATUS_WAIT_CHECK_SIGN_APPROVE:
        text = '待重新提交'
        break
      case ORDER_STATUS_WAIT_PD_TECH_AUDIT:
        text = '产品类技术审核中'
        break
      case ORDER_STATUS_WAIT_PD_TECH_AUDIT_FAIL:
        text = '产品类审核不通过'
        break
      default:
        text = '执行中'
    }
  }
  return text
}

function getStatusStyle (order) {
  let background = 'alert-background'
  switch (order.status) {
    case ORDER_STATUS_DRAFT:
    case ORDER_STATUS_SUBMITTED:
      background = 'alert-background'
      break
    case ORDER_STATUS_FINISHED:
      background = 'green-background'
      break
    case ORDER_STATUS_ABORT:
      background = 'alert-background'
      break
    case ORDER_STATUS_SIGN_NEED:
      background = 'alert-background'
      break
    case ORDER_STATUS_CHECK:
      background = 'alert-background'
      break
    case ORDER_STATUS_CHECK_BAD:
      background = 'alert-background'
      break
    case ORDER_STATUS_WAIT_PD_TECH_AUDIT:
      background = 'alert-background'
      break
    case ORDER_STATUS_WAIT_PD_TECH_AUDIT_FAIL:
      background = 'alert-background'
      break
    default:
      background = 'orange-background'
  }
  return ['order-status', 'tiny-font', background]
}

function filterOrderListBySearchMap (orderList, searchMap) {
  let ignoreKeywordSearch = !searchMap.keyword
  let ignoreMemberSearch = !searchMap.memberNames || searchMap.memberNames.length === 0
  if (ignoreKeywordSearch && ignoreMemberSearch) return orderList
  return orderList.filter(order => {
    const targetOrderNo = ignoreKeywordSearch || order.orderNo.toLowerCase().includes(searchMap.keyword.toLowerCase())
    const targetContract = ignoreKeywordSearch || order.itemList.map(item => item.contractNo && item.contractNo.toLowerCase()).join(',').includes(searchMap.keyword.toLowerCase())
    const targetCustomer = ignoreMemberSearch || searchMap.memberNames.includes(order.orderPerson)
    return targetCustomer && (targetOrderNo || targetContract)
  })
}
function setOrderMerchandiseWithMeta (orders) {
  for (let i = 0; i < orders.length; i++) {
    let order = orders[i]
    if (order.merchandises[0]) {
      order.merchandises[0].productName = order.productName
    }
    setMerchandiseDetailForClient(order.merchandises)
  }
}

function setMerchandiseDetailForClient (merchandises) {
  if (merchandises) {
    merchandises.forEach(function (item) {
      let mer = item.merchandiseDetailForClient
      if (mer) {
        if (mer.categoryId === 10 || mer.categoryId === 20) {
          setMerchandiseDetailForClientCustom(item)
        }
        merchandiseWithMeta(mer)
        item._attributesList = mer._attributesList
        item._titleList = mer._titleList
        item._subTitleList = mer._subTitleList
        item._attributes = mer._attributes
        item._abstractList = mer._abstractList
        item.priceMax = mer.priceMax
      }
    })
  }
}

function setMerchandiseDetailForClientCustom (item) {
  let attributes = item.attributes
  let obj = {}
  let mer = item.merchandiseDetailForClient
  attributes.forEach(data => {
    let key = data.key
    let val = data.value
    obj[key] = val
  })
  mer.productName = item.productName
  mer.attributes = obj
  mer.cycle = item.workdays
  mer.priceMax = item.priceMax
  mer.priceMin = item.priceMin
  // mer.priceMax = item.price
  // mer.priceMin = item.price
  mer.productGuid = item.productGuid
  return mer
}

function dealMetaData (response) {
  if (response) {
    var merchandiseMeta = response
    var detaillist
    var categoryAttrsMap = {}
    // var dictionariesMapNew = {}
    var dictionariesMap = {}
    var tagsMap = {}
    var tagIdsMap = {}
    var tagNamesMap = {}
    var dictionaries
    var categoryAttrGroups
    var categoryAttrGroupsMap = {}
    var tags
    var categories
    var categoriesMap = {}
    // var val = []
    detaillist = merchandiseMeta.categoryAttrs
    dictionaries = merchandiseMeta.dictionaries
    categoryAttrGroups = merchandiseMeta.categoryAttrGroups
    tags = merchandiseMeta.tags
    categories = merchandiseMeta.categories

    for (var j = 0; j < dictionaries.length; j++) {
      var dkey = dictionaries[j].typeID + '_' + dictionaries[j].dictKey
      var dvalue = dictionaries[j]
      var keyNew = dictionaries[j].typeID
      dictionariesMap[dkey] = dvalue
      var dictionariesEntry = dictionariesMap[keyNew]
      if (!dictionariesEntry) {
        dictionariesMap[keyNew] = {}
        dictionariesEntry = dictionariesMap[keyNew]
      }
      dictionariesEntry[dictionaries[j].dictKey] = dvalue
    }

    for (j = 0; j < categoryAttrGroups.length; j++) {
      var k = categoryAttrGroups[j].attrGroupId
      var v = categoryAttrGroups[j]
      categoryAttrGroupsMap[k] = v
    }

    for (var i = 0; i < detaillist.length; i++) {
      var attrsMap = categoryAttrsMap[detaillist[i].categoryId]
      if (!attrsMap) {
        attrsMap = {}
        categoryAttrsMap[detaillist[i].categoryId] = attrsMap
      }

      // var key = detaillist[i].categoryId + '_' + detaillist[i].columnName
      var value = detaillist[i]
      // categoryAttrsMap[key] = value
      attrsMap[detaillist[i].columnName] = value
    }
    for (let k = 0; k < tags.length; k++) {
      var tkey = tags[k].tagId
      var tvalue = tags[k]
      tagsMap[tkey] = tvalue
    }
    for (let k = 0; k < tags.length; k++) {
      var tidkey = tags[k].tagId
      var tidvalue = tags[k].tagLabel
      tagIdsMap[tidkey] = tidvalue
    }
    for (let k = 0; k < tags.length; k++) {
      var tnamekey = tags[k].tagLabel
      var tnamevalue = tags[k].tagId
      tagNamesMap[tnamekey] = tnamevalue
    }
    for (let i = 0; i < categories.length; i++) {
      var cate = categories[i].categoryId
      var cateValue = categories[i]
      categoriesMap[cate] = cateValue
    }

    merchandiseMeta.categoryAttrsMap = categoryAttrsMap
    merchandiseMeta.dictionariesMap = dictionariesMap
    merchandiseMeta.categoryAttrGroupsMap = categoryAttrGroupsMap
    merchandiseMeta.tagsMap = tagsMap
    merchandiseMeta.tagIdsMap = tagIdsMap
    merchandiseMeta.tagNamesMap = tagNamesMap
    merchandiseMeta.keywordMeanings = merchandiseMeta.keywordMeanings
    merchandiseMeta.categoriesMap = categoriesMap
    setLocalStorage('EmktAllKeywords', {}) // 同时要清空keyWords
    if (!window.localStorage) {
      // window.localStorage.clear()
    }
    if (isDebug) {
      window.alert('merchandiseMeta=' + merchandiseMeta)
    }
    setEmktMetaData(merchandiseMeta)
  }
}

function showDownloadOrderTextBtn (orderDetail) {
  if (!orderDetail) return false
  let statusText = getOrderStatusText(orderDetail)
  const orderSourceQualified = orderDetail.orderSource !== ORDER_SOURCE.OFFLINE
  const orderStatusQualified = (statusText === '已完成' || statusText === '执行中')
  return orderSourceQualified && orderStatusQualified
}

function showProgressBtn (orderDetail) {
  if (!orderDetail) return false
  let statusText = getOrderStatusText(orderDetail)
  const orderStatusQualified = (statusText === '已完成' || statusText === '执行中')
  return orderStatusQualified
}

function isGVAPContract (orderDetail) {
  if (!orderDetail) return false
  let orderItem = orderDetail.itemList && orderDetail.itemList[0]
  return orderItem && orderItem.contractNo && orderItem.contractNo.indexOf('GVAP') > -1
}

/**
 * 复制: 拼装订单详细信息文本
 * @param orderDetail
 */
function assembleOrderDetailText (orderDetail, itemListLength, balanceTypeName, payTypeName, deliverMethod) {
  if (!orderDetail) return ''
  const productsDetail = orderDetail.itemList && orderDetail.itemList.map(item => {
    const getItemLabel = (item) => `${(item.TLNo || '')} ${(item.tag1PUBID || '')} ${(item.eu_RID || '')} ${(item.tax || '')} ${(item.symbol || '')}`
    return `${item.name} ${item.orderType === 1 ? 'X' + item.quantity : ''}  ${formatPrice(item.price)}\n` +
      `${item.contractNo ? item.contractNo + '\n' : ''}` +
      `${getItemLabel(item) ? getItemLabel(item) + '\n' : ''}`
  }).join('\n')
  return `订单编号：${orderDetail.orderNo} \n\n` +
    `${productsDetail} \n` +
    `商品总额：¥${formatPrice(orderDetail.initPrice)} \n` +
    `优惠折扣：-¥${formatPrice(orderDetail.discountPrice)} \n` +
    `运费：¥${formatPrice(orderDetail.expressPrice)} \n` +
    `共${itemListLength}件商品   合计: ¥${formatPrice(orderDetail.price)} \n\n` +
    `结算方式: ${balanceTypeName} \n` +
    `支付方式：${payTypeName} \n` +
    `${orderDetail.sfQuoteNo ? ('报价编号：' + orderDetail.sfQuoteNo + '\n') : ''}` +
    `配送方式：${deliverMethod} \n` +
    `下单时间：${orderDetail.orderTime} \n`
}

function convertProduct (data) {
  data.attributes = data.smartProductParameterSelection
  let _attributesList = []
  let _titleList = []
  let _subTitleList = []
  let _abstractList = []
  data.smartAttributes.forEach(par => {
    let options = {}
    if (par.metaType === 1) {
      let p = data.productParameters.find(item => item.parameterGuid === par.parameterGuid)
      if (p) {
        console.log(p)
        p.displayOptions && p.displayOptions.forEach(sys => {
          options[sys.dictKey] = sys.dictValue
        })
      }
    }
    let attr = {
      label: par.keyLabel,
      value: par.value,
      sdType: par.dataType,
      groupId: 2,
      sortOrder: 1,
      keyFeature: 1,
      displayable: par.displayable,
      columnName: par.key,
      sectionId: 0,
      options: options
    }
    if (par.key.indexOf('GeneInfo') !== -1 && par.displayable === 1 && par.value) {
      _subTitleList.push({
        valueText: par.valueLabel
      })
    }
    if (par.key === 'TVInfo' && par.value) {
      _abstractList.push({
        valueText: par.valueLabel
      })
    }
    _attributesList.push(attr)
  })
  data._attributesList = _attributesList
  data._subTitleList = _subTitleList
  data._abstractList = _abstractList
  let name = {}
  name.valueText = data.name
  _titleList.push(name)
  data._titleList = _titleList
  data.discountPrice = 0
  data.productName = data.erpProductName
  data.productGuid = data.erpProductGuid
  data.workdays = data.workdays
  data.price = data.price
  data.expressPrice = 0
  data.productQuantity = 1
  data.merchandiseId = data.guid
  data.muGuid = data.guid
  data.SKUID = data.guid
  return data
}

const PRODUCT_TYPE_TAG_MAP = {
  [PRODUCT_TYPE_ID.instantStock]: {
    tagName: '现货',
    tagTheme: 'primary'
  },
  [PRODUCT_TYPE_ID.produceStock]: {
    tagName: '现货',
    tagTheme: 'primary'
  },
  [PRODUCT_TYPE_ID.customMade]: {
    tagName: '定制',
    tagTheme: 'danger'
  },
  [PRODUCT_TYPE_ID.reagent]: {
    tagName: '现货',
    tagTheme: 'primary'
  },
  [PRODUCT_TYPE_ID.amplification]: {
    tagName: '扩增',
    tagTheme: 'warning'
  }
}
const PRODUCT_FILTER_RECORD_KEY_GENE = 'GeneInfo'
const PRODUCT_FILTER_RECORD_KEY_VECTOR = 'TVInfo'

// 基因、载体、转录本，展示信息定义
const GENE_DISPLAY_ATTRIBUTES = ['symbol', 'taxId']
const TRANSCRIPT_DISPLAY_ATTRIBUTES = ['NMID', 'subtype']
const VECTOR_DISPLAY_ATTRIBUTES = ['elementSeq', 'tlNo', 'promoterID', 'tag1ID', 'tag2ID', 'eu_RID']
/**
 *
 * @param emktRoute 拼装跳转rtmes- h5页面的url
 * @returns
 */
function assembleSmartLink (samrtRoute) {
  const targetLocation = `${MERCHANDISE_IMG_BASE_URL_RTMES}${window.location.search}#/${samrtRoute}`
  console.log('assembleSmartLink', targetLocation)
  return targetLocation
}
function goCart (router) {
  if (getUrlParamHref('fromSmart') === '1') {
    window.location.href = assembleSmartLink('cart')
  } else {
    router.replace({name: 'cart'})
  }
}
export default
{
  assembleOrderDetailText,
  goCart,
  isGVAPContract,
  showProgressBtn,
  showDownloadOrderTextBtn,
  filterOrderListBySearchMap,
  dealMetaData,
  setOrderMerchandiseWithMeta,
  getStatusStyle,
  getOrderStatusText,
  SDTString,
  SDTInteger,
  SDTEnumeration,
  SDTDate,
  SDTDateTime,
  SDTGene,
  SDTDecimal,
  SDTToolVector,
  Rat,
  Mouse,
  Human,
  others,
  Gallusgallus,
  thalecress,
  rice,
  zebrafish,
  fruitfly,
  pig,
  sheep,
  rabbit,
  domesticsilkworm,
  Africanclawedfrog,
  yeast,
  taxTypeId,
  CONST_MESSAGE_STATUS_NONE,
  CONST_MESSAGE_STATUS_NEW_MESSAGE,
  CONST_MESSAGE_STATUS_NEW_RESPONSE,
  CONST_MESSAGE_STATUS_RESPONSE_READ,

  CONST_MESSAGE_TYPE_CUSTOMER_REQUEST,
  CONST_MESSAGE_TYPE_CUSTOMER_SERVICE_RESPONSE,

  throttle,
  setStoreItem,
  getStoreItem,
  removeStoreItem,
  setLocalStorage,
  getLocalStorage,
  getEmktMetaVersion,
  getEmktMetaData,
  setEmktMetaData,
  merchandiseWithMeta,
  getUrlParam,
  getFullUrlParam,
  getUrlFullParamValue,
  publicUrl,
  wxShareUrl,
  // wxShare,
  isDebug,
  isDesktop,
  isWapp,
  isWappGuest,
  isSecPromotion,
  isResearchGroup,
  getUrlParamHref,
  isNullOrBlankObject,
  formatPrice,
  buyCartIsLocalStorage,
  setBuyCart,
  customerBehaviours,
  QUERY_ORDER_TYPE,
  initCustomerBehaviour,
  getMerchandiseLabelPath,
  getOrderMerchandiseLabel,
  getMerchandiseLabelImg,
  behaviour,
  customerBehaviourType,
  researchServiceCategory,
  lotteryStartDT,
  lotteryEndDT,
  christmasPreSalePeriod,
  researchGroupDictionary,
  researchGroupMemberDictionary,
  researchGroupDetailDisplayOrder,
  researchGroupApproveTypeDictionary,
  researchGroupStatusDictionary,
  testCustomerNo,
  testEnterpriseNo,
  promotions618,
  COUPON_TYPE_DISCOUNT,
  COUPON_TYPE_NEW_DISCOUNT,
  COUPON_TYPE_SPECIAL_FUND,
  COUPON_TYPE,
  CONSTANT_APPROVETYPE_THRESHOLD,
  CONSTANT_APPROVETYPE_ALL,
  CONSTANT_APPROVETYPE_NONE,
  RESEARCH_GROUP_APPROVE_RESULT_NEED_NOT_APPROVE,
  RESEARCH_GROUP_APPROVE_RESULT_NOT_OPERATED,
  RESEARCH_GROUP_APPROVE_RESULT_WAIT_APPROVE,
  RESEARCH_GROUP_APPROVE_RESULT_APPROVED,
  RESEARCH_GROUP_APPROVE_RESULT_NOT_APPROVED,
  ORDER_STATUS_DRAFT,
  ORDER_STATUS_SUBMITTED,
  ORDER_STATUS_PAIED,
  ORDER_STATUS_FINISHED,
  ORDER_STATUS_CONTRACT,
  ORDER_STATUS_ABORT,
  ORDER_STATUS_CHECK,
  ORDER_STATUS_CHECK_BAD,
  ORDER_STATUS_SIGN_NEED,
  ORDER_STATUS_WAIT_CHECK_SIGN_APPROVE,
  ORDER_STATUS_WAIT_PD_TECH_AUDIT,
  ORDER_STATUS_WAIT_PD_TECH_AUDIT_FAIL,
  BALANCE_TYPE_RESEARCH_GROUP,
  BALANCE_TYPE_CUSTOMER,
  PAY_TYPE_REMAIN_MONEY,
  PAY_TYPE_FAPIAO,
  RESEARCH_GROUP_STATUS_DISABLE,
  RESEARCH_GROUP_STATUS_NORMAL,
  RESEARCH_GROUP_STATUS_LOCKED,
  RESEARCH_GROUP_STATUS_EXPIRED,
  PRODUCT_TYPE_TOOL,
  CUSTOMIZE_IMAGE,
  MYORDER_TAB_WAITPAY,
  MYORDER_TAB_EXECUTE,
  MYORDER_TAB_FINISHED,
  MYORDER_TAB_CANCELLED,
  isIphoneFullScreen,
  leaveSpaceForFullScreen,
  benefitDiscount,
  CONSTANT_SET_MOUNTH_APPROVETYPE,
  CONSTANT_SET_SINGLESTORKE_APPROVETYPE,
  CONSTANT_ALL_APPROVETYPE,
  SETTLEMENT_ACCOUNT_STATUS_DISABLE,
  SETTLEMENT_ACCOUNT_STATUS_NORMAL,
  SETTLEMENT_ACCOUNT_STATUS_LOCKED,
  openCustomerService,
  SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP,
  extraBloodType,
  activityName,
  promotionGuid,
  PRIZE_TYPE_OBJECT,
  PRIZE_TYPE_COUPON,
  AuthenticationID,
  HardGeneLevelNo1,
  HardGeneLevelNo2,
  ENTERPRISE_TYPE_COMPANY,
  TOOLTYPE_LENTIVIRUS,
  TOOLTYPE_PLASMID,
  TOOLTYPE_ADENOVIRUS,
  TOOLTYPE_RETROVIRUS,
  TOOLTYPE_FLOATVIRUS,
  AAVBLOODTYPETWO,
  AAVBLOODTYPESIX,
  VIRUSTITER1E13,
  VIRUSTITER5E12,
  AMPLIFICATION,
  CUSTOMERPROVIDED,
  ORDER_SOURCE,
  TOOLTYPE_ADENOVIRUSABOUT,
  PRODUCT_TYPE_SERVICE_CONSTANT,
  ADDRESS_STATUS,
  ADDRESS_SOURCE,
  getFileSuffix,
  getOrderMaterialFileShowIcon,
  reassembleOrderMaterialInfo,
  MATERIAL_TYPE,
  MATERIAL_FILETYPE,
  DELIVERY_ADDRESS,
  SAMPLE_DISPLAY_TYPE,
  SAMPLE_DELIVERY_FORM_TYPE,
  MATERIAL_STATIC_FILE_BASE_URL,
  MERCHANDISE_IMG_BASE_URL,
  WAPP_LOGIN_TYPE_DICTIONARY,
  WAPP_LOGIN_TYPE_CODE,
  WAPP_LOGIN_TYPE_WX,
  ORDER_TYPE_SERVICE,
  ADBERRATION_EXCHANGE,
  ADBERRATION_RETROACTION,
  ADBERRATION_MESSAGE,
  ADBERRATION_REPORT,
  EXPERIMENT_MODULES_STATUS_NAME_NOT_START,
  EXPERIMENT_MODULES_STATUS_NAME__ON_GOING,
  EXPERIMENT_MODULES_STATUS_NAME__ENDING,
  EXPERIMENT_MODULES_STATUS_NAME__END_STOP,
  EXPERIMENT_MODULES_STATUS_CANNOT_START,
  EXPERIMENT_MODULES_STATUS_NOT_START,
  EXPERIMENT_MODULES_STATUS_ON_GOING,
  EXPERIMENT_MODULES_STATUS_ENDING,
  EXPERIMENT_MODULES_STATUS_END_STOP,
  EXPERIMENT_MODULES_STATUS_NAME_EXCEPTION,
  EXPERIMENT_MODULES_STATUS_READY_START,
  EXPERIMENT_MODULES_STATUS_STOP,
  ADBERRATION_STATUS,
  COUPON_ACTIVITY_TYPE_COUPON,
  COUPON_ACTIVITY_TYPE_GROUP_BUY,
  COUPON_ACTIVITY_TYPE_ANNIVERSARY,
  FindSourceCrm,
  RESEARCH_MEMBER_OP,
  FormatterTime,
  TV_NO_PATH,
  convertProduct,
  ICON_TAG_IMAGE_MAP,
  PRODUCT_TYPE_ID,
  PRODUCT_CATEGORY_ICON_TAG_AMPLIFICATION,
  PRODUCT_CATEGORY_ICON_TAG_STOCK,
  PRODUCT_CATEGORY_ICON_TAG_CUSTOMIZE,
  MERCHANDISE_IMG_BASE_URL_RTMES,
  MERCHANDISE_IMG_BASE_URL_SMART,
  PRODUCT_TYPE_TAG_MAP,
  PRODUCT_FILTER_RECORD_KEY_GENE,
  GENE_DISPLAY_ATTRIBUTES,
  TRANSCRIPT_DISPLAY_ATTRIBUTES,
  VECTOR_DISPLAY_ATTRIBUTES,
  PRODUCT_FILTER_RECORD_KEY_VECTOR,
  MYORDER_TAB_WAITAUDIT
}




// WEBPACK FOOTER //
// ./src/emktcommon/constant.js